import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SponsoredAdsNav from './SponsoredAdsNav';
import Campaigns from './Campaigns/Campaigns';
import AdSets from './AdSets/AdSets';
import Ads from './Ads/Ads';
import BannerAds from './BannerAds/BannerAds';
import AdUsers from './AdUsers/AdUsers';
import SponsoredAdsDashboard from './Dashboard/SponsoredAdsDashboard';
import Component from '../../components/Component';

const SponsoredAds = () => {
  return (
    <Component>
      <div className="sponsored-ads-container" style={{ 
        marginLeft: '280px', 
        marginTop: '80px',
        padding: '20px',
        width: 'calc(100% - 280px)'
      }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Sponsored Ads</h2>
        </div>

        <SponsoredAdsNav />

        <Routes>
          <Route path="/" element={<SponsoredAdsDashboard />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/ad-sets" element={<AdSets />} />
          <Route path="/ads" element={<Ads />} />
          <Route path="/banner-ads" element={<BannerAds />} />
          <Route path="/users" element={<AdUsers />} />
        </Routes>
      </div>
    </Component>
  );
};

export default SponsoredAds; 